import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";
import { formatDeviceAddress } from "utilities/DeviceNameFormatter";

const LINE_MAP_PLACEHOLDER = <React.Fragment><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell></React.Fragment>;

const MAX_DN_NETWORK_DEVICES = 70;

const START_MULTIPLIER = 10;
const END_INCREMENT = 10;

const UtilsInstance = new Utils();

class LiveList extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      sortDirection: "ascending",
      devices: [],
      devicesMatrixList: [],
      firstLineMap: LINE_MAP_PLACEHOLDER,
      secondLineMap: LINE_MAP_PLACEHOLDER,
      thirdLineMap: LINE_MAP_PLACEHOLDER,
      fourthLineMap: LINE_MAP_PLACEHOLDER,
      fifthLineMap: LINE_MAP_PLACEHOLDER,
      sixthLineMap: LINE_MAP_PLACEHOLDER,
      seventhLineMap: LINE_MAP_PLACEHOLDER,
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  retrieveData = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "liveList/fisic", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => this.setState({ devices: data }, () => {
        this.setState({ devicesMatrixList: [] }, () => {
          this.createLiveListMatrixList();
          this.buildLineMaps();
        });
      }))
      .catch((e) => {
        console.log("Request interrupted: ", e);
      });
  }

  createLiveListMatrixList = () => {
    let totalNumOfDevices = this.state.devices.length;
    let numOfInsertedDevices = 0;

    for (let i = 0; i < MAX_DN_NETWORK_DEVICES; i++) {
      let hasPositionBeenFilled = false;

      // Only look for devices to insert if not all of them have been already inserted
      if (numOfInsertedDevices < totalNumOfDevices) {
        for (let j = 0; j < this.state.devices.length; j++) {
          if (this.state.devices[j].address === i || this.state.devices[j].addressMestre === i) {
            this.state.devicesMatrixList.push(this.state.devices[j]);
            hasPositionBeenFilled = true;
            numOfInsertedDevices++;
            break;
          }
        }
      }

      if (!hasPositionBeenFilled) {
        this.state.devicesMatrixList.push({
          "aOk": true,
          "address": i,
          "amplitudeMedia": 0,
          "amplitudeMinima": 0,
          "bOk": true,
          "overshooting": 0,
          "status": ""
        });
      }

    }
  }

  buildLineMaps = () => {
    let firstLineStart = START_MULTIPLIER * (1 - 1);
    let firstLineEnd = firstLineStart + END_INCREMENT;

    let secondLineStart = START_MULTIPLIER * (2 - 1);
    let secondLineEnd = secondLineStart + END_INCREMENT;

    let thirdLineStart = START_MULTIPLIER * (3 - 1);
    let thirdLineEnd = thirdLineStart + END_INCREMENT;

    let fourthLineStart = START_MULTIPLIER * (4 - 1);
    let fourthLineEnd = fourthLineStart + END_INCREMENT;

    let fifthLineStart = START_MULTIPLIER * (5 - 1);
    let fifthLineEnd = fifthLineStart + END_INCREMENT;

    let sixthLineStart = START_MULTIPLIER * (6 - 1);
    let sixthLineEnd = sixthLineStart + END_INCREMENT;

    let seventhLineStart = START_MULTIPLIER * (7 - 1);
    let seventhLinEnd = seventhLineStart + END_INCREMENT;

    let firstLine = this.state.devicesMatrixList.slice(firstLineStart, firstLineEnd);
    let secondLine = this.state.devicesMatrixList.slice(secondLineStart, secondLineEnd);
    let thirdLine = this.state.devicesMatrixList.slice(thirdLineStart, thirdLineEnd);
    let fourthLine = this.state.devicesMatrixList.slice(fourthLineStart, fourthLineEnd);
    let fifthLine = this.state.devicesMatrixList.slice(fifthLineStart, fifthLineEnd);
    let sixthLine = this.state.devicesMatrixList.slice(sixthLineStart, sixthLineEnd);
    let seventhLine = this.state.devicesMatrixList.slice(seventhLineStart, seventhLinEnd);

    this.setState({
      firstLineMap: firstLine.map(device => (this.createDeviceCell(device))),
      secondLineMap: secondLine.map(device => (this.createDeviceCell(device))),
      thirdLineMap: thirdLine.map(device => (this.createDeviceCell(device))),
      fourthLineMap: fourthLine.map(device => (this.createDeviceCell(device))),
      fifthLineMap: fifthLine.map(device => (this.createDeviceCell(device))),
      sixthLineMap: sixthLine.map(device => (this.createDeviceCell(device))),
      seventhLineMap: seventhLine.map(device => (this.createDeviceCell(device))),
    });
  }

  createDeviceCell = (device) => {
    if (device.status === Constants.GOOD) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={goodCellStyle}>
          {device.mestre
            ? formatDeviceAddress("Mestre -", Strings)
            : ""} {Strings.GOOD_STRING_ANALYZER_DN}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.ATTENTION) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={attentionCellStyle}>
          {device.mestre
            ? formatDeviceAddress("Mestre", Strings)
            : ""} {Strings.ATTENTION_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.BAD) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={badCellStyle}>
          {device.mestre
            ? formatDeviceAddress("Mestre", Strings)
            : ""} {Strings.BAD_STRING_ANALYZER_DN}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          disabled
          key={device.address}
          style={hiddenTableCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  getTableBasedOnWindowHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();

    let browserHeightStyle = {
      height: browserHeight * 0.85
    };

    let tableSize = "large";

    if (browserHeight > 800) {
      browserHeightStyle = {
        height: browserHeight * 0.85
      };
      tableSize = "large";
    }
    else if (browserHeight > 650 && browserHeight <= 800) {
      browserHeightStyle = {
        height: browserHeight * 0.85
      };
      tableSize = "small";
    }
    else {
      browserHeightStyle = {
        height: browserHeight * 0.65
      };
      tableSize = "small";
    }

    return (
      <Table id="main-table" compact celled fixed singleLine textAlign="center" size={tableSize} definition style={browserHeightStyle}>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell width="1" />
            <Table.HeaderCell>0</Table.HeaderCell>
            <Table.HeaderCell>1</Table.HeaderCell>
            <Table.HeaderCell>2</Table.HeaderCell>
            <Table.HeaderCell>3</Table.HeaderCell>
            <Table.HeaderCell>4</Table.HeaderCell>
            <Table.HeaderCell>5</Table.HeaderCell>
            <Table.HeaderCell>6</Table.HeaderCell>
            <Table.HeaderCell>7</Table.HeaderCell>
            <Table.HeaderCell>8</Table.HeaderCell>
            <Table.HeaderCell>9</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row> <Table.Cell verticalAlign="middle">0</Table.Cell> {this.state.firstLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">10</Table.Cell> {this.state.secondLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">20</Table.Cell> {this.state.thirdLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">30</Table.Cell> {this.state.fourthLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">40</Table.Cell> {this.state.fifthLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">50</Table.Cell> {this.state.sixthLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">60</Table.Cell> {this.state.seventhLineMap} </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 1000) });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  // Render the table containing all network devices
  render() {
    return (
      <div style={screenStyle}>
        {this.getTableBasedOnWindowHeight()}
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  marginRight: "1vw",
  marginLeft: "1vw",
  textAlign: "center"
};

const goodCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const attentionCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const hiddenTableCellStyle = {
  color: "white"
};

export default withRouter(LiveList);
